import { useEffect } from "react";
import useTenant from "src/hooks/api/services/tenants/useTenant";

function useTenantTheme() {
	const { tenant } = useTenant();
	useEffect(() => {
		const body = document.querySelector("body");
		if (!body?.classList.contains(tenant.slug)) {
			body?.classList.add(tenant.slug);
		}
		// if (tenant?.slug) {
		// 	require(`../../public/themes/${tenant.slug}.css`);
		// }
	}, [tenant]);
}

export default useTenantTheme;
